module.exports = __webpack_public_path__ + "media/images/common/navbar_logo-fa8f119970e5c0e3bcde2e82e664b508.png";